<artemis-sidebar></artemis-sidebar>
<div class="artemis-content__container">
  <artemis-header (toggleSidebar)="headerToggleSidebarHandler($event)"></artemis-header>
  <div #content class="scroll-on-page-background artemis-content" cdkScrollable>
    <div class="artemis-content__page-body-container">
      <router-outlet></router-outlet>
    </div>
    <div class="copyright">
      <span>Copyright © 2022 Cynopsis Solutions Pte. Ltd.</span>
      <span>All Rights Reserved</span>
    </div>
  </div>
</div>
